import CheckmarkIcon_default from "../../icons/CheckmarkIcon.js";
import { Flex } from "../Layout/Flex/Flex.js";
import { Checkbox } from "../Checkbox/Checkbox.js";
import { MenuDescendantsProvider, MenuProvider, createStylesContext, useMenu, useMenuButton, useMenuContext, useMenuItem, useMenuList, useMenuOption, useMenuOptionGroup, useMenuPositioner } from "@chakra-ui/react";
import { chakra as chakra$1, forwardRef as forwardRef$1, omitThemingProps, useMultiStyleConfig as useMultiStyleConfig$1 } from "@chakra-ui/system";
import { motion } from "motion/react";
import { c } from "react-compiler-runtime";
import * as React$1 from "react";
import { jsx, jsxs } from "react/jsx-runtime";
import { cx, runIfFn } from "@chakra-ui/utils";

//#region src/components/Dropdown/Dropdown.base.tsx
const [StylesProvider, useStyles$1] = createStylesContext("Menu");
/**
* Menu provides context, state, and focus management
* to its sub-components. It doesn't render any DOM node.
*/
const Menu = (props) => {
	const $ = c(19);
	const { children } = props;
	const styles = useMultiStyleConfig$1("Menu", props);
	let t0;
	if ($[0] !== props) {
		t0 = omitThemingProps(props);
		$[0] = props;
		$[1] = t0;
	} else t0 = $[1];
	const ownProps = t0;
	const t1 = useMenu(ownProps);
	let ctx;
	let descendants;
	if ($[2] !== t1) {
		({descendants, ...ctx} = t1);
		$[2] = t1;
		$[3] = ctx;
		$[4] = descendants;
	} else {
		ctx = $[3];
		descendants = $[4];
	}
	let t2;
	t2 = ctx;
	const context = t2;
	const { isOpen, onClose, forceUpdate } = context;
	let t3;
	if ($[5] !== children || $[6] !== forceUpdate || $[7] !== isOpen || $[8] !== onClose) {
		t3 = runIfFn(children, {
			isOpen,
			onClose,
			forceUpdate
		});
		$[5] = children;
		$[6] = forceUpdate;
		$[7] = isOpen;
		$[8] = onClose;
		$[9] = t3;
	} else t3 = $[9];
	let t4;
	if ($[10] !== styles || $[11] !== t3) {
		t4 = /* @__PURE__ */ jsx(StylesProvider, {
			value: styles,
			children: t3
		});
		$[10] = styles;
		$[11] = t3;
		$[12] = t4;
	} else t4 = $[12];
	let t5;
	if ($[13] !== context || $[14] !== t4) {
		t5 = /* @__PURE__ */ jsx(MenuProvider, {
			value: context,
			children: t4
		});
		$[13] = context;
		$[14] = t4;
		$[15] = t5;
	} else t5 = $[15];
	let t6;
	if ($[16] !== descendants || $[17] !== t5) {
		t6 = /* @__PURE__ */ jsx(MenuDescendantsProvider, {
			value: descendants,
			children: t5
		});
		$[16] = descendants;
		$[17] = t5;
		$[18] = t6;
	} else t6 = $[18];
	return t6;
};
Menu.displayName = "Menu";
const StyledMenuButton = forwardRef$1((props, ref) => {
	const $ = c(6);
	const styles = useStyles$1();
	let t0;
	if ($[0] !== styles.button) {
		t0 = {
			display: "inline-flex",
			appearance: "none",
			alignItems: "center",
			outline: 0,
			...styles.button
		};
		$[0] = styles.button;
		$[1] = t0;
	} else t0 = $[1];
	let t1;
	if ($[2] !== props || $[3] !== ref || $[4] !== t0) {
		t1 = /* @__PURE__ */ jsx(chakra$1.button, {
			ref,
			...props,
			__css: t0
		});
		$[2] = props;
		$[3] = ref;
		$[4] = t0;
		$[5] = t1;
	} else t1 = $[5];
	return t1;
});
/**
* The trigger for the menu list. Must be a direct child of `Menu`.
*/
const MenuButton = forwardRef$1((props, ref) => {
	const $ = c(14);
	let As;
	let rest;
	if ($[0] !== props) {
		({as: As, ...rest} = props);
		$[0] = props;
		$[1] = As;
		$[2] = rest;
	} else {
		As = $[1];
		rest = $[2];
	}
	const buttonProps = useMenuButton(rest, ref);
	const Element = As || StyledMenuButton;
	let t0;
	if ($[3] !== props.className) {
		t0 = cx("chakra-menu__menu-button", props.className);
		$[3] = props.className;
		$[4] = t0;
	} else t0 = $[4];
	let t1;
	if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
		t1 = {
			pointerEvents: "none",
			flex: "1 1 auto",
			minW: 0,
			display: "flex",
			alignItems: "center",
			justifyContent: "center"
		};
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props.children) {
		t2 = /* @__PURE__ */ jsx(chakra$1.span, {
			__css: t1,
			children: props.children
		});
		$[6] = props.children;
		$[7] = t2;
	} else t2 = $[7];
	let t3;
	if ($[8] !== Element || $[9] !== buttonProps || $[10] !== ref || $[11] !== t0 || $[12] !== t2) {
		t3 = /* @__PURE__ */ jsx(Element, {
			ref,
			...buttonProps,
			className: t0,
			children: t2
		});
		$[8] = Element;
		$[9] = buttonProps;
		$[10] = ref;
		$[11] = t0;
		$[12] = t2;
		$[13] = t3;
	} else t3 = $[13];
	return t3;
});
MenuButton.displayName = "MenuButton";
const motionVariants = {
	enter: {
		visibility: "visible",
		opacity: 1,
		scale: 1,
		transition: {
			duration: .2,
			ease: [
				.4,
				0,
				.2,
				1
			]
		}
	},
	exit: {
		transitionEnd: { visibility: "hidden" },
		opacity: 0,
		scale: .8,
		transition: {
			duration: .1,
			ease: "easeOut"
		}
	}
};
const ChakraDiv = chakra$1("div");
const MotionDiv = motion.create(ChakraDiv);
const MenuList = forwardRef$1((props, ref) => {
	const $ = c(22);
	let rest;
	let rootProps;
	let t0;
	let t1;
	if ($[0] !== props) {
		({rootProps, disableAnimation: t0, bare: t1, ...rest} = props);
		$[0] = props;
		$[1] = rest;
		$[2] = rootProps;
		$[3] = t0;
		$[4] = t1;
	} else {
		rest = $[1];
		rootProps = $[2];
		t0 = $[3];
		t1 = $[4];
	}
	const disableAnimation = t0 === void 0 ? false : t0;
	const bare = t1 === void 0 ? false : t1;
	const { isOpen, onTransitionEnd } = useMenuContext();
	const menulistProps = useMenuList(rest, ref);
	const positionerProps = useMenuPositioner(rootProps);
	const styles = useStyles$1();
	const t2 = props.zIndex ?? styles.list?.zIndex;
	let t3;
	if ($[5] !== t2) {
		t3 = { zIndex: t2 };
		$[5] = t2;
		$[6] = t3;
	} else t3 = $[6];
	const t4 = bare ? "chakra-menu__menu-bare-list" : void 0;
	let t5;
	if ($[7] !== menulistProps.className || $[8] !== t4) {
		t5 = cx("chakra-menu__menu-list", t4, menulistProps.className);
		$[7] = menulistProps.className;
		$[8] = t4;
		$[9] = t5;
	} else t5 = $[9];
	const t6 = disableAnimation ? false : isOpen ? "enter" : "exit";
	const t7 = bare ? null : styles.list;
	let t8;
	if ($[10] !== t7) {
		t8 = {
			outline: 0,
			...t7
		};
		$[10] = t7;
		$[11] = t8;
	} else t8 = $[11];
	let t9;
	if ($[12] !== menulistProps || $[13] !== onTransitionEnd || $[14] !== t5 || $[15] !== t6 || $[16] !== t8) {
		t9 = /* @__PURE__ */ jsx(MotionDiv, {
			...menulistProps,
			onUpdate: onTransitionEnd,
			className: t5,
			variants: motionVariants,
			initial: false,
			animate: t6,
			__css: t8
		});
		$[12] = menulistProps;
		$[13] = onTransitionEnd;
		$[14] = t5;
		$[15] = t6;
		$[16] = t8;
		$[17] = t9;
	} else t9 = $[17];
	let t10;
	if ($[18] !== positionerProps || $[19] !== t3 || $[20] !== t9) {
		t10 = /* @__PURE__ */ jsx(ChakraDiv, {
			...positionerProps,
			__css: t3,
			children: t9
		});
		$[18] = positionerProps;
		$[19] = t3;
		$[20] = t9;
		$[21] = t10;
	} else t10 = $[21];
	return t10;
});
MenuList.displayName = "MenuList";
const StyledMenuItem = forwardRef$1((props, ref) => {
	const $ = c(17);
	let colorScheme;
	let rest;
	let type;
	if ($[0] !== props) {
		({type, colorScheme, ...rest} = props);
		$[0] = props;
		$[1] = colorScheme;
		$[2] = rest;
		$[3] = type;
	} else {
		colorScheme = $[1];
		rest = $[2];
		type = $[3];
	}
	const styles = useStyles$1();
	const itemStyles = styles.item;
	const btnType = rest.as ? type ?? void 0 : "button";
	let t0;
	if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
		t0 = {
			display: "flex",
			alignItems: "center"
		};
		$[4] = t0;
	} else t0 = $[4];
	let t1;
	if ($[5] !== colorScheme || $[6] !== itemStyles) {
		t1 = colorScheme && { ...colorScheme === "error" && {
			color: "error.main",
			"& svg.chakra-menu__icon": {
				...itemStyles["& svg.chakra-menu__icon"],
				color: "error.main"
			},
			_focus: {
				...itemStyles._focus,
				color: "error.main",
				"& svg.chakra-menu__icon": {
					...itemStyles._focus?.["& svg.chakra-menu__icon"],
					color: "error.main"
				}
			}
		} };
		$[5] = colorScheme;
		$[6] = itemStyles;
		$[7] = t1;
	} else t1 = $[7];
	let t2;
	if ($[8] !== itemStyles || $[9] !== props.__css || $[10] !== t1) {
		t2 = {
			textDecoration: "none",
			color: "inherit",
			userSelect: "none",
			display: "flex",
			width: "100%",
			alignItems: "center",
			textAlign: "start",
			flex: "0 0 auto",
			outline: 0,
			"& > span": t0,
			...itemStyles,
			...props.__css,
			...t1
		};
		$[8] = itemStyles;
		$[9] = props.__css;
		$[10] = t1;
		$[11] = t2;
	} else t2 = $[11];
	const buttonStyles = t2;
	let t3;
	if ($[12] !== btnType || $[13] !== buttonStyles || $[14] !== ref || $[15] !== rest) {
		t3 = /* @__PURE__ */ jsx(chakra$1.button, {
			ref,
			type: btnType,
			...rest,
			__css: buttonStyles
		});
		$[12] = btnType;
		$[13] = buttonStyles;
		$[14] = ref;
		$[15] = rest;
		$[16] = t3;
	} else t3 = $[16];
	return t3;
});
const MenuIcon = (props) => {
	const $ = c(13);
	let children;
	let className;
	let rest;
	if ($[0] !== props) {
		({className, children, ...rest} = props);
		$[0] = props;
		$[1] = children;
		$[2] = className;
		$[3] = rest;
	} else {
		children = $[1];
		className = $[2];
		rest = $[3];
	}
	let t0;
	if ($[4] !== children) {
		const child = React$1.Children.only(children);
		t0 = React$1.isValidElement(child) ? React$1.cloneElement(child, {
			focusable: "false",
			"aria-hidden": true,
			className: cx("chakra-menu__icon", child.props.className)
		}) : null;
		$[4] = children;
		$[5] = t0;
	} else t0 = $[5];
	const clone = t0;
	let t1;
	if ($[6] !== className) {
		t1 = cx("chakra-menu__icon-wrapper", className);
		$[6] = className;
		$[7] = t1;
	} else t1 = $[7];
	const _className = t1;
	let t2;
	if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
		t2 = { flexShrink: 0 };
		$[8] = t2;
	} else t2 = $[8];
	let t3;
	if ($[9] !== _className || $[10] !== clone || $[11] !== rest) {
		t3 = /* @__PURE__ */ jsx(chakra$1.span, {
			className: _className,
			...rest,
			__css: t2,
			children: clone
		});
		$[9] = _className;
		$[10] = clone;
		$[11] = rest;
		$[12] = t3;
	} else t3 = $[12];
	return t3;
};
MenuIcon.displayName = "MenuIcon";
const MenuCommand = forwardRef$1((props, ref) => {
	const $ = c(4);
	const styles = useStyles$1();
	let t0;
	if ($[0] !== props || $[1] !== ref || $[2] !== styles.command) {
		t0 = /* @__PURE__ */ jsx(chakra$1.span, {
			ref,
			...props,
			__css: styles.command,
			className: "chakra-menu__command"
		});
		$[0] = props;
		$[1] = ref;
		$[2] = styles.command;
		$[3] = t0;
	} else t0 = $[3];
	return t0;
});
MenuCommand.displayName = "MenuCommand";
const MenuItem = forwardRef$1((props, ref) => {
	const $ = c(26);
	let children;
	let colorScheme;
	let command;
	let icon;
	let rest;
	let t0;
	let t1;
	if ($[0] !== props) {
		({icon, iconSpacing: t0, command, commandSpacing: t1, colorScheme, children, ...rest} = props);
		$[0] = props;
		$[1] = children;
		$[2] = colorScheme;
		$[3] = command;
		$[4] = icon;
		$[5] = rest;
		$[6] = t0;
		$[7] = t1;
	} else {
		children = $[1];
		colorScheme = $[2];
		command = $[3];
		icon = $[4];
		rest = $[5];
		t0 = $[6];
		t1 = $[7];
	}
	const iconSpacing = t0 === void 0 ? 2 : t0;
	const commandSpacing = t1 === void 0 ? 2 : t1;
	const menuitemProps = useMenuItem(rest, ref);
	const shouldWrap = icon || command;
	let t2;
	if ($[8] !== children || $[9] !== shouldWrap) {
		t2 = shouldWrap ? /* @__PURE__ */ jsx("span", {
			style: {
				pointerEvents: "none",
				flex: 1
			},
			children
		}) : children;
		$[8] = children;
		$[9] = shouldWrap;
		$[10] = t2;
	} else t2 = $[10];
	const _children = t2;
	let t3;
	if ($[11] !== menuitemProps.className) {
		t3 = cx("chakra-menu__menuitem", menuitemProps.className);
		$[11] = menuitemProps.className;
		$[12] = t3;
	} else t3 = $[12];
	let t4;
	if ($[13] !== icon || $[14] !== iconSpacing) {
		t4 = icon && /* @__PURE__ */ jsx(MenuIcon, {
			fontSize: "0.8em",
			marginEnd: iconSpacing,
			children: icon
		});
		$[13] = icon;
		$[14] = iconSpacing;
		$[15] = t4;
	} else t4 = $[15];
	let t5;
	if ($[16] !== command || $[17] !== commandSpacing) {
		t5 = command && /* @__PURE__ */ jsx(MenuCommand, {
			marginStart: commandSpacing,
			children: command
		});
		$[16] = command;
		$[17] = commandSpacing;
		$[18] = t5;
	} else t5 = $[18];
	let t6;
	if ($[19] !== _children || $[20] !== colorScheme || $[21] !== menuitemProps || $[22] !== t3 || $[23] !== t4 || $[24] !== t5) {
		t6 = /* @__PURE__ */ jsxs(StyledMenuItem, {
			...menuitemProps,
			className: t3,
			colorScheme,
			children: [
				t4,
				_children,
				t5
			]
		});
		$[19] = _children;
		$[20] = colorScheme;
		$[21] = menuitemProps;
		$[22] = t3;
		$[23] = t4;
		$[24] = t5;
		$[25] = t6;
	} else t6 = $[25];
	return t6;
});
MenuItem.displayName = "MenuItem";
const MenuGroup = forwardRef$1((props, ref) => {
	const $ = c(17);
	let children;
	let className;
	let rest;
	let title;
	if ($[0] !== props) {
		({title, children, className, ...rest} = props);
		$[0] = props;
		$[1] = children;
		$[2] = className;
		$[3] = rest;
		$[4] = title;
	} else {
		children = $[1];
		className = $[2];
		rest = $[3];
		title = $[4];
	}
	let t0;
	if ($[5] !== className) {
		t0 = cx("chakra-menu__group__title", className);
		$[5] = className;
		$[6] = t0;
	} else t0 = $[6];
	const _className = t0;
	const styles = useStyles$1();
	let t1;
	if ($[7] !== _className || $[8] !== rest || $[9] !== styles.groupTitle || $[10] !== title) {
		t1 = title && /* @__PURE__ */ jsx(chakra$1.p, {
			className: _className,
			...rest,
			__css: styles.groupTitle,
			children: title
		});
		$[7] = _className;
		$[8] = rest;
		$[9] = styles.groupTitle;
		$[10] = title;
		$[11] = t1;
	} else t1 = $[11];
	let t2;
	if ($[12] !== children || $[13] !== ref || $[14] !== styles.group || $[15] !== t1) {
		t2 = /* @__PURE__ */ jsxs(chakra$1.div, {
			ref,
			className: "chakra-menu__group",
			role: "group",
			__css: styles.group,
			children: [t1, children]
		});
		$[12] = children;
		$[13] = ref;
		$[14] = styles.group;
		$[15] = t1;
		$[16] = t2;
	} else t2 = $[16];
	return t2;
});
MenuGroup.displayName = "MenuGroup";
const MenuItemOption = forwardRef$1((props, ref) => {
	const $ = c(22);
	let icon;
	let rest;
	let t0;
	if ($[0] !== props) {
		({icon, iconSpacing: t0, ...rest} = props);
		$[0] = props;
		$[1] = icon;
		$[2] = rest;
		$[3] = t0;
	} else {
		icon = $[1];
		rest = $[2];
		t0 = $[3];
	}
	const iconSpacing = t0 === void 0 ? 2 : t0;
	const optionProps = useMenuOption(rest, ref);
	let t1;
	if ($[4] !== rest.className) {
		t1 = cx("chakra-menu__menuitem-option", rest.className);
		$[4] = rest.className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== icon || $[7] !== iconSpacing) {
		t2 = icon && /* @__PURE__ */ jsx(MenuIcon, {
			fontSize: "0.8em",
			marginEnd: iconSpacing,
			children: icon
		});
		$[6] = icon;
		$[7] = iconSpacing;
		$[8] = t2;
	} else t2 = $[8];
	let t3;
	if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
		t3 = { flex: 1 };
		$[9] = t3;
	} else t3 = $[9];
	let t4;
	if ($[10] !== optionProps.children) {
		t4 = /* @__PURE__ */ jsx("span", {
			style: t3,
			children: optionProps.children
		});
		$[10] = optionProps.children;
		$[11] = t4;
	} else t4 = $[11];
	const t5 = props.isChecked ? 1 : 0;
	let t6;
	if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
		t6 = /* @__PURE__ */ jsx(CheckmarkIcon_default, { size: "xs" });
		$[12] = t6;
	} else t6 = $[12];
	let t7;
	if ($[13] !== iconSpacing || $[14] !== t5) {
		t7 = /* @__PURE__ */ jsx(MenuIcon, {
			fontSize: "0.8em",
			marginStart: iconSpacing,
			opacity: t5,
			children: t6
		});
		$[13] = iconSpacing;
		$[14] = t5;
		$[15] = t7;
	} else t7 = $[15];
	let t8;
	if ($[16] !== optionProps || $[17] !== t1 || $[18] !== t2 || $[19] !== t4 || $[20] !== t7) {
		t8 = /* @__PURE__ */ jsxs(StyledMenuItem, {
			...optionProps,
			className: t1,
			children: [
				t2,
				t4,
				t7
			]
		});
		$[16] = optionProps;
		$[17] = t1;
		$[18] = t2;
		$[19] = t4;
		$[20] = t7;
		$[21] = t8;
	} else t8 = $[21];
	return t8;
});
MenuItemOption.id = "MenuItemOption";
MenuItemOption.displayName = "MenuItemOption";
const MenuCheckboxItem = forwardRef$1((props, ref) => {
	const $ = c(17);
	let checkboxProps;
	let label;
	let rest;
	if ($[0] !== props) {
		({label, checkboxProps, ...rest} = props);
		$[0] = props;
		$[1] = checkboxProps;
		$[2] = label;
		$[3] = rest;
	} else {
		checkboxProps = $[1];
		label = $[2];
		rest = $[3];
	}
	const optionProps = useMenuOption(rest, ref);
	const styles = useStyles$1();
	let t0;
	if ($[4] !== rest.className) {
		t0 = cx("chakra-menu__menuitem-option", rest.className);
		$[4] = rest.className;
		$[5] = t0;
	} else t0 = $[5];
	let t1;
	if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
		t1 = { pointerEvents: "none" };
		$[6] = t1;
	} else t1 = $[6];
	let t2;
	if ($[7] !== checkboxProps) {
		t2 = /* @__PURE__ */ jsx(Checkbox, {
			size: "sm",
			colorScheme: "primary",
			sx: t1,
			...checkboxProps
		});
		$[7] = checkboxProps;
		$[8] = t2;
	} else t2 = $[8];
	let t3;
	if ($[9] !== label || $[10] !== t2) {
		t3 = /* @__PURE__ */ jsxs(Flex, {
			flex: 1,
			gap: 1,
			alignItems: "center",
			children: [t2, label]
		});
		$[9] = label;
		$[10] = t2;
		$[11] = t3;
	} else t3 = $[11];
	let t4;
	if ($[12] !== optionProps || $[13] !== styles.checkboxItem || $[14] !== t0 || $[15] !== t3) {
		t4 = /* @__PURE__ */ jsx(StyledMenuItem, {
			...optionProps,
			className: t0,
			__css: styles.checkboxItem,
			children: t3
		});
		$[12] = optionProps;
		$[13] = styles.checkboxItem;
		$[14] = t0;
		$[15] = t3;
		$[16] = t4;
	} else t4 = $[16];
	return t4;
});
MenuCheckboxItem.id = "MenuItemOption";
MenuCheckboxItem.displayName = "MenuItemOption";
const MenuOptionGroup = (props) => {
	const $ = c(10);
	let className;
	let rest;
	let title;
	if ($[0] !== props) {
		({className, title, ...rest} = props);
		$[0] = props;
		$[1] = className;
		$[2] = rest;
		$[3] = title;
	} else {
		className = $[1];
		rest = $[2];
		title = $[3];
	}
	const ownProps = useMenuOptionGroup(rest);
	let t0;
	if ($[4] !== className) {
		t0 = cx("chakra-menu__option-group", className);
		$[4] = className;
		$[5] = t0;
	} else t0 = $[5];
	let t1;
	if ($[6] !== ownProps || $[7] !== t0 || $[8] !== title) {
		t1 = /* @__PURE__ */ jsx(MenuGroup, {
			title,
			className: t0,
			...ownProps
		});
		$[6] = ownProps;
		$[7] = t0;
		$[8] = title;
		$[9] = t1;
	} else t1 = $[9];
	return t1;
};
MenuOptionGroup.displayName = "MenuOptionGroup";
const MenuDivider = (props) => {
	const $ = c(9);
	let className;
	let rest;
	if ($[0] !== props) {
		({className, ...rest} = props);
		$[0] = props;
		$[1] = className;
		$[2] = rest;
	} else {
		className = $[1];
		rest = $[2];
	}
	const styles = useStyles$1();
	let t0;
	if ($[3] !== className) {
		t0 = cx("chakra-menu__divider", className);
		$[3] = className;
		$[4] = t0;
	} else t0 = $[4];
	let t1;
	if ($[5] !== rest || $[6] !== styles.divider || $[7] !== t0) {
		t1 = /* @__PURE__ */ jsx(chakra$1.hr, {
			role: "separator",
			"aria-orientation": "horizontal",
			className: t0,
			...rest,
			__css: styles.divider
		});
		$[5] = rest;
		$[6] = styles.divider;
		$[7] = t0;
		$[8] = t1;
	} else t1 = $[8];
	return t1;
};
MenuDivider.displayName = "MenuDivider";

//#endregion
export { Menu, MenuButton, MenuCheckboxItem, MenuDivider, MenuGroup, MenuItem, MenuItemOption, MenuList, MenuOptionGroup, StylesProvider, useStyles$1 as useStyles };
//# sourceMappingURL=Dropdown.base.js.map